import { Component, Input } from "@angular/core";

import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-asset-summary",
	templateUrl: "./asset-summary.component.html",
	styleUrls: ["./asset-summary.component.scss"]
})
export class AssetSummaryComponent {
	@Input()
	asset: APIResults.FleetAsset;

	public brand = BrandVars;

}
